import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  initialTicketDetailsState,
  TicketingApiResponseStatus,
} from '@Src/store/types';
import { getTicketDetailsApi } from '@Src/apiServices/ticketingService';
import { RootState } from '@Src/store';
import { apiLoading, apiRejected } from '@Src/store/reducers/Ticketing/helpers';

export const fetchTicketDetails = createAsyncThunk(
  'fetchTicketDetails',
  async (fetchTicketDetailsApiRequest: any) => {
    const { ticketId, appSource } = fetchTicketDetailsApiRequest;
    return getTicketDetailsApi(ticketId, appSource);
  }
);

export const ticketDetailsSlice = createSlice({
  name: 'ticketDetailsSlice',
  initialState: initialTicketDetailsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTicketDetails.pending, apiLoading)
      .addCase(fetchTicketDetails.rejected, apiRejected)
      .addCase(fetchTicketDetails.fulfilled, (state, action) => {
        state.ticketItem = ((TicketItem) => TicketItem)(action.payload);
        state.status = TicketingApiResponseStatus.succeeded;
      });
  },
});

export const getTicketItem = (store: RootState) =>
  store.ticketDetailsReducer.ticketItem;
export const getTicketDetailsStatus = (store: RootState) =>
  store.ticketDetailsReducer.status;

export default ticketDetailsSlice.reducer;
